var render = function render(){var _vm=this,_c=_vm._self._c;return _c('text-box',{attrs:{"label":_vm.$t('components.simulationDetails.RoasByChannel.title'),"icon":"chart-bar","warnings":_vm.warnings}},[_vm._t("default"),_c('v-chart',{style:(`width: 100%; height: ${_vm.chartHeight}px;`),attrs:{"option":_vm.options,"init-options":_vm.chartInitOptions,"update-options":_vm.chartUpdateOptions,"autoresize":""}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }